/**
 * Legacy ApiService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.api`) keep resolving.
 *
 * The actual `ApiService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts as a downgrade
 * of the unified Angular 18 ApiService at
 * apps/b2b-frontend/app/core/api/api.service.ts.
 *
 * The Angular 18 facade exposes `user` and `system` as native sub-services
 * (HttpClient + typed responses); the remaining ~55 sub-services keep their
 * AngularJS implementations for now and are accessed lazily through
 * `$injector` until each one is migrated in a follow-up PR.
 *
 * Do NOT register `.service('ApiService', ...)` here — it would shadow the
 * downgraded service.
 */
angular.module('acme.common.service.api', [
  'acme.common.service.administrationApi',
  'acme.common.service.analyticsApi',
  'acme.common.service.cartApi',
  'acme.common.service.comboApi',
  'acme.common.service.couponsApi',
  'acme.common.service.customFieldsApi',
  'acme.common.service.customerFeesApi',
  'acme.common.service.rateCardsApi',
  'acme.common.service.customerServiceApi',
  'acme.common.service.customersApi',
  'acme.common.service.departmentsApi',
  'acme.common.service.discountsApi',
  'acme.common.service.donationsApi',
  'acme.common.service.emailStatusApi',
  'acme.common.service.entityApi',
  'acme.common.service.entitlementsApi',
  'acme.common.service.eventApi',
  'acme.common.service.featureToggle',
  'acme.common.service.financeApi',
  'acme.common.service.formApi',
  'acme.common.service.glcodesApi',
  'acme.common.service.groupsApi',
  'acme.common.service.historyApi',
  'acme.common.service.inventoryApi',
  'acme.common.service.inventoryB2CApi',
  'acme.common.service.importJobsApi',
  'acme.common.service.importJobExecutionsApi',
  'acme.common.service.importExportsApi',
  'acme.common.service.lockApi',
  'acme.common.service.membershipApi',
  'acme.common.service.navigationApi',
  'acme.common.service.offline',
  'acme.common.service.ordersApi',
  'acme.common.service.organizationsApi',
  'acme.common.service.partnersApi',
  'acme.common.service.passesApi',
  'acme.common.service.permissionsApi',
  'acme.common.service.photosApi',
  'acme.common.service.posApi',
  'acme.common.service.posCloudConfiguration',
  'acme.common.service.priceApi',
  'acme.common.service.programApi',
  'acme.common.service.proxyUserApi',
  'acme.common.service.refundsApi',
  'acme.common.service.reportingApi',
  'acme.common.service.reservation',
  'acme.common.service.resourceApi',
  'acme.common.service.rolesApi',
  'acme.common.service.rulesEngineApi',
  'acme.common.service.settlementsApi',
  'acme.common.service.subscriptionsApi',
  'acme.common.service.systemApi',
  'acme.common.service.tenantApi',
  'acme.common.service.terminalsApi',
  'acme.common.service.themesApi',
  'acme.common.service.ticketsApi',
  'acme.common.service.userApi',
  'acme.common.service.userPreferencesApi',
  'acme.common.service.walkinsApi',
  'acme.common.service.loggerApi',
  'acme.common.service.dedupeApi',
  'acme.common.service.textVariablesApi',
  'acme.common.service.householdApi',
  'acme.common.service.sfdcApi',
])
// Provider endpoint configuration — preserved from the original legacy
// `.config()` block in api.service.js. These providers expose `setEndpoint()`
// at config time and use it lazily inside their `$get()` factories; without
// this block the endpoint stays `undefined` and `$http` rejects with
// `[$http:badreq]`. The Angular 18 ApiService facade only handles services
// that use `init(endpoint)` at runtime (LEGACY_SUB_SERVICES_TO_INIT) and
// cannot reach config-phase providers, so this block has to live here.
.config([
  'FeatureToggleServiceProvider',
  'ImportJobsApiServiceProvider',
  'ImportJobExecutionsApiServiceProvider',
  'ImportExportsApiServiceProvider',
  'OfflineServiceProvider',
  'PosCloudConfigurationServiceProvider',
  'ReservationApiServiceProvider',
  function (
    FeatureToggleServiceProvider,
    ImportJobsApiServiceProvider,
    ImportJobExecutionsApiServiceProvider,
    ImportExportsApiServiceProvider,
    OfflineServiceProvider,
    PosCloudConfigurationServiceProvider,
    ReservationApiServiceProvider
  ) {
    FeatureToggleServiceProvider.setEndpoint('/service/feature/toggles');
    ImportJobsApiServiceProvider.setEndpoint('/service/import/api/job');
    ImportJobExecutionsApiServiceProvider.setEndpoint('/service/import/api');
    ImportExportsApiServiceProvider.setEndpoint('/service/import/api/export');
    OfflineServiceProvider.setEndpoint('/v2/api/b2c/checkout/pointofsale/offline');
    PosCloudConfigurationServiceProvider.setEndpoint('/v2/api/configuration/pos');
    ReservationApiServiceProvider.setEndpoint('/v2/api/reservations');
  }
]);
